import { getFontStyles } from '@ycos/primitives'
import mrpStyles from './../mrp.json'

export default {
  ...getFontStyles(mrpStyles, { type: 'Heading', name: 'A2' }),
  color: mrpStyles.colors.PrimaryBlack,
  lineColor: mrpStyles.colors.SecondaryGreySteel,
  textTransform: 'none',
  loyaltyFontStyle: {
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '24px'
  }
}
